export default __webpack_public_path__ + "static/media/user.6ef639f4.svg";